export enum FormFieldId {
    contactId = 'contactId',
    addressId = 'addressId',
}

export interface FormValues {
    [FormFieldId.contactId]: string | null;
    [FormFieldId.addressId]: string | null;
}
